import type posthog from 'posthog-js';

export type PostHogClient = typeof posthog;

let client: PostHogClient | null = null;
let pendingIdentity: string | null = null;
let resetPending = false;

export function getPostHogClient(): PostHogClient | null {
  return client;
}

export function setPostHogClient(nextClient: PostHogClient): void {
  client = nextClient;

  if (resetPending) {
    client.reset();
    resetPending = false;
  }

  if (pendingIdentity) {
    client.identify(pendingIdentity);
    pendingIdentity = null;
  }
}

export function identifyWithPostHog(userId: string): void {
  if (client?.__loaded) {
    client.identify(userId);
    return;
  }

  pendingIdentity = userId;
}

export function resetPostHogIdentity(): void {
  pendingIdentity = null;

  if (client?.__loaded) {
    client.reset();
    return;
  }

  resetPending = true;
}
